<script>
import ModuleTitle from '../common/ModuleTitle.vue'

import { getShadowColor } from '@/utils/modules/getStyles'
import { filtersRichtext, textLenHandler } from '@/utils/common'

export default {
  name: 'Comp43',
  components: { ModuleTitle },
  props: {
    moduleOption: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      path: this.$route.path
    }
  },
  methods: {
    getShadowColor, filtersRichtext, textLenHandler,
    onModuleItem(v) {
      this.$emit('onModuleItem', v)
    }
  }
}
</script>

<template>
  <div class="modules-id-45">
    <module-title :title="moduleOption.title" margin-bottom="24" />
    <div class="comp-transverse-2 modules-id-45-content">
      <div
        v-for="(v, i) in moduleOption.list.slice(0, 5)"
        :key="`modules-id-45-item-${i}`"
        class="item"
        :class="[{'odd-item': i % 2 !== 0, 'fifth-item': i === 4}, `item-${i}`]"
        @click="onModuleItem(v)"
      >
        <div class="memo-box">
          <p class="item-headline">{{ v.headline | textLenHandler(5) }}</p>
          <p class="item-memo">{{ textLenHandler(filtersRichtext(v.memo), 30) }}</p>
        </div>
        <div v-if="i !== 4" class="line"></div>
        <div class="img-box" :class="{'sec-img-box': i === 1}">
          <img class="item-img" :src="v.photo | imgPath" alt="img">
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.modules-id-45-content {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  column-gap: 16px;
  row-gap: 60px;
  padding: 0 0 0 30px;
  box-sizing: border-box;
  position: relative;
  .item {
    width: 300px;
    height: 114px;
    box-sizing: border-box;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    .img-box {
      width: 110px;
      height: 110px;
      .item-img {
        width: 110px;
        height: 110px;
        border-radius: 50%;
        border: 7px solid transparent;
        background-image: linear-gradient(#fff, #fff), linear-gradient(180deg, #06eafb, #0df2b8);
        background-origin: border-box;
        background-clip: content-box, border-box;
        object-fit: cover;
      }
    }
    .memo-box {
      width: 108px;
      .item-headline {
        width: 108px;
        font-size: 15px;
        font-weight: bold;
        color: #228E76;
        font-family: siyuansong;
      }
      .item-memo {
        width: 108px;
        font-size: 13px;
        font-weight: bold;
        color: #268877;
        margin-top: 8px;
      }
    }
  }
  .odd-item {
    display: flex;
    flex-direction: row-reverse;
  }
  .fifth-item {
    display: flex;
    flex-direction: row-reverse;
    position: absolute;
    top: 100px;
    left: 150px;
    .memo-box {
      width: 148px;
    }
  }
  .item-1 {
    .img-box {
      width: 88px;
      height: 88px;
      .item-img {width: 88px;height: 88px;}
    }
  }
  .item-2 {
    .img-box {
      width: 96px;
      height: 96px;
      .item-img {width: 96px;height: 96px;}
    }
  }
  .item-3 {
    .img-box {
      width: 88px;
      height: 88px;
      .item-img {width: 88px;height: 88px;}
    }
  }
  .item-4 {
    .img-box {
      width: 105px;
      height: 105px;
      .item-img {width: 105px;height: 105px;}
    }
  }
}
.line {
  width: 52px;
  height: 2px;
  background-color: #268877;
}
</style>
